<form [formGroup]="clientInfoForm" class="customer-info-form" novalidate>
  <div class="customer-info-form__header">
    <p class="h6 mb-1">Dados do cliente</p>
    <p class="customer-info-form__description mb-0">
      Preencha os dados de quem vai receber esta compra.
    </p>
  </div>

  <div class="mb-3">
    <label for="client_name" class="form-label">Nome Completo</label>
    <input
      id="client_name"
      type="text"
      class="form-control"
      formControlName="client_name"
      autocomplete="name"
      placeholder="Digite o nome do cliente"
      [ngClass]="{
        'is-invalid': hasError('client_name'),
      }" />
    @if (hasError("client_name")) {
      <div class="invalid-feedback">
        @if (clientInfoForm.get("client_name")?.hasError("required")) {
          Informe o nome completo do cliente.
        } @else if (clientInfoForm.get("client_name")?.hasError("invalidName")) {
          Voc&ecirc; deve inserir nome e sobrenome.
        } @else {
          Nome muito pequeno.
        }
      </div>
    }
  </div>

  <div class="form-check form-switch mb-3">
    <input
      class="form-check-input"
      type="checkbox"
      id="is_foreign_client"
      formControlName="is_foreign_client" />
    <label class="form-check-label ms-2" for="is_foreign_client"> &Eacute; estrangeiro? </label>
  </div>

  @if (clientInfoForm.get("is_foreign_client")?.value) {
    <div class="mb-3">
      <label for="client_country" class="form-label">Pa&iacute;s</label>
      <select
        id="client_country"
        class="form-select"
        formControlName="client_country"
        [ngClass]="{
          'is-invalid': hasError('client_country'),
        }">
        @for (country of countriesList; track country.acronym) {
          <option [value]="country.acronym">{{ country.name }}</option>
        }
      </select>
      @if (hasError("client_country")) {
        <div class="invalid-feedback">Informe o pa&iacute;s do cliente.</div>
      }
    </div>

    <div class="mb-3">
      <label for="client_document" class="form-label">Documento de identidade (estrangeiro)</label>
      <input
        id="client_document"
        type="text"
        class="form-control"
        formControlName="client_document"
        autocomplete="off"
        placeholder="Passaporte, DNI, RNE..."
        [ngClass]="{
          'is-invalid': hasError('client_document'),
        }" />
      @if (hasError("client_document")) {
        <div class="invalid-feedback">
          Informe o documento internacional do cliente.
        </div>
      }
    </div>
  } @else {
    <div class="mb-3">
      <label for="client_cpf" class="form-label">CPF</label>
      <input
        id="client_cpf"
        type="text"
        class="form-control"
        formControlName="client_cpf"
        autocomplete="off"
        inputmode="numeric"
        placeholder="000.000.000-00"
        mask="000.000.000-00"
        [ngClass]="{
          'is-invalid': hasError('client_cpf'),
        }" />
      @if (hasError("client_cpf")) {
        <div class="invalid-feedback">
          @if (clientInfoForm.get("client_cpf")?.hasError("required")) {
            Informe o CPF do cliente.
          } @else {
            Informe um CPF v&aacute;lido.
          }
        </div>
      }
    </div>
  }

  <div class="mb-3">
    <label for="client_email" class="form-label">E-mail</label>
    <input
      id="client_email"
      type="email"
      class="form-control"
      formControlName="client_email"
      autocomplete="email"
      placeholder="cliente@exemplo.com"
      [ngClass]="{
        'is-invalid': hasError('client_email'),
      }" />
    @if (hasError("client_email")) {
      <div class="invalid-feedback">
        @if (clientInfoForm.get("client_email")?.hasError("required")) {
          Informe o e-mail do cliente.
        } @else {
          Informe um e-mail v&aacute;lido.
        }
      </div>
    }
  </div>

  <div class="mb-3">
    <div class="customer-info-form__phone">
      <div>
        <label for="client_phone_country_code" class="form-label">DDI</label>
        <app-ddi-select
          id="client_phone_country_code"
          formControlName="client_phone_country_code"></app-ddi-select>
      </div>

      <div class="customer-info-form__phone-number">
        <label for="client_phone" class="form-label">Celular</label>
        <input
          id="client_phone"
          type="text"
          class="form-control"
          formControlName="client_phone"
          autocomplete="tel"
          inputmode="numeric"
          placeholder="(00) 00000-0000"
          [mask]="clientInfoForm.get('client_phone_country_code')?.value === '+55' ? '(00) 00000-0000' : ''"
          [ngClass]="{
            'is-invalid': hasError('client_phone'),
          }" />
        @if (hasError("client_phone")) {
          <div class="invalid-feedback">
            Informe um celular v&aacute;lido do cliente.
          </div>
        }
      </div>
    </div>
  </div>
</form>
